/* eslint-disable react/jsx-key */
import React from 'react';
import { Wrapper } from '../styled';
import { StyledLabel, LoadingWrapper, LoadingIcon } from './styled';
import { useIntl } from 'react-intl';
import LoadingGif from 'Images/faraday_loadingbar.gif';
import { getGroupingCommandProgressLabel } from 'Common/Components/FileUploadContext/groupingCommands';

const Processing = ({ commandType }) => {
  const intl = useIntl();

  const label = () => {
    const groupingLabel = getGroupingCommandProgressLabel(commandType);
    if (groupingLabel) return groupingLabel;
    if (commandType === 'moveAssets') return 'Moving assets...';
    if (commandType === 'risk_score_recalculation') return 'Recalculating risk scores...';
    return intl.formatMessage({ id: 'uploadContext.status.inProgress' });
  };

  return (
    <Wrapper>
      <StyledLabel children={ label() } />
      <LoadingWrapper children={ <LoadingIcon src={ LoadingGif } /> } />
    </Wrapper>
  );
};

export default Processing;
